/*
 * • FCSE Travelsearch Sandbox 2013 •
 * 
 * © Copyright 2012, Tom Hülser [freshcells systems engineering GmbH]
 * 
 * 
 */


/**
 * Logging
 * 
 * @author Hermann Bier, bier@freshcells.de
 */
define(['jQuery'], function($) {
  
  return function(debugPrefix) {
    this.debugPrefix = debugPrefix || '';
    this.layerMaxHeight = "200";
    this.layerMinHeight = "40";
    
    this.debug = function(message, dump) 
    {
      message = this.debugPrefix + ': '+ message;

      if(this.debuging())
      {
        if(typeof console.debug == 'undefined')
        {
          console.log(message);
        }
        else if(dump)
        {
          console.debug(message, dump);
        }
        else
        {
          console.debug(message);
        }
      }
//      else if(this.debugingIE())
//      {
//        // logging for msie, #messages must be available
//        $('#messages').append(message + '<br/>');
//      }
    };

    this.error = function(error)
    {
      error = this.debugPrefix + ': '+ error;
      
      if(this.debuging() && typeof console.error != 'undefined')
      {
        console.error(error);
      }
//      else if(this.debugingIE())
//      {
//        // logging for msie, #messages must be available
//        $('#messages').append('<span class="error">' + error + '</span>' + '<br/>');
//      }
    };


    this.warn = function(warn)
    {
      warn = this.debugPrefix + ': '+ warn;
      
      if(this.debuging() && typeof console.warn != 'undefined')
      {
        console.warn(warn);
      }
//      else if(this.debugingIE())
//      {
//        // logging for msie, #messages must be available
//        $('#messages').append('<span class="error">' + error + '</span>' + '<br/>');
//      }
    };

    this.timeStart = function(label)
    {
      if(this.debuging() && typeof console.time != 'undefined')
      {
        console.time(label);
      }
    };

    this.timeEnd = function(label)
    {
      if(this.debuging() && typeof console.timeEnd != 'undefined')
      {
        console.timeEnd(label);
      }
    };

    this.createLayer = function() 
    {
      if(this.layer) return;
      this.layer = $('<div style="position:relative; height: ' + this.layerMinHeight + 'px; background-color: #fff; overflow: auto"></div>');
      $('body').prepend(this.layer);
      // checkbox to lock size
      var checkbox = $('<input type="checkbox" style="position: absolute; top: 10px; left: ' + (this.layer.width() - 20) + 'px;"/>');
      this.layer.append(checkbox);
      var self = this;
      // let it grow
      this.layer.on({
        mouseenter: function()
        {
          if(checkbox.is(':checked')) return;
          $(this).stop().animate({height: self.layerMaxHeight});
        },
        mouseleave: function()
        {
          if(checkbox.is(':checked')) return;
          $(this).stop().animate({height: self.layerMinHeight});
        }
      });
    };
    
    this.debugLayer = function(message) 
    {
      if(!GLOBAL_DEBUG) return;
      this.createLayer();
      this.layer.append('<p style="font-size: 10px;">' + this.debugPrefix + ': ' + message + '</p>');
    };
    
    
    /**
    * Should message be ouptuted
    */
    this.debuging = function()
    {
      return GLOBAL_DEBUG && typeof window.console != 'undefined';
    };
    /**
    * Same for IE
    */
    this.debugingIE = function()
    {
      return GLOBAL_DEBUG && $('#messages').length != 0;
    };
  };
});




//////////////////
// WEBPACK FOOTER
// ./~/fcse-logging/log.js
// module id = 86
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23